export const CONSENT_KEY = "pp_cookie_consent";

export const getCookieConsent = () => { try { return JSON.parse(localStorage.getItem(CONSENT_KEY)); } catch { return null; } };
